import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultiResIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m3 18 9-12 9 12",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 3,
			cy: 18,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 6,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 18,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("path", { d: "m3 18 4.5-6L12 6l4.5 6 4.5 6" }),
		/* @__PURE__ */ _jsx("path", {
			d: "m7.5 12 4.5 6m4.5-6L12 18",
			opacity: .4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.5,
			cy: 12,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16.5,
			cy: 12,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 18,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgMultiResIcon;
